import { render, staticRenderFns } from "./PointsManage.vue?vue&type=template&id=8ed2c0b2&scoped=true&"
import script from "./PointsManage.vue?vue&type=script&lang=js&"
export * from "./PointsManage.vue?vue&type=script&lang=js&"
import style0 from "./PointsManage.vue?vue&type=style&index=0&id=8ed2c0b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed2c0b2",
  null
  
)

export default component.exports